module.exports = __webpack_public_path__ + "img/de_beauvoir.0fad9922.png";